import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { ContactUsService } from "../../Forms/contact-us.service";
import {
  NavigationStart,
  Router,
  Event,
  ActivatedRoute,
} from "@angular/router";
import { PlatformLocation } from "@angular/common";
import { MembershipService } from "../../membership/membership.service";
import { environment } from "src/environments/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AboutUsService } from "src/app/about-us/about-us.service";
import { EncryptDecryptService } from "src/app/encrypt-decrypt.service";
import { CookieService } from "ngx-cookie-service";		
										   
declare var $: any;

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  submitted = false;
  formVar: FormGroup;
  public emailPattern = environment.emailPattern;
  public phonePattern = environment.phonePattern;
  isNoForm = true;
  currentUrl;
  PlanID;
  AGBTPlans;
  noFooter = false;
  Version = environment.version;
  bannerDetails;
  videoCdnUrl = environment.googleCDNUrl;
  isSuccess = false;
  isError = false;
  isFieldValidation = false;
  loader = false;
  isLoggedIn=false;
  isReadOnly=false;		
  UserName;	
  Email;
  PhoneNumber;	 

  constructor(
    private fb: FormBuilder,
    private contactusService: ContactUsService,
    private router: Router,
    location: PlatformLocation,
    private route: ActivatedRoute,
    private memberShipService: MembershipService,
    private _snackBar: MatSnackBar,
    private aboutUsService: AboutUsService,
    private encDecService: EncryptDecryptService,
	 private  cookieService :CookieService									 
  ) {
    this.router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        location.onPopState(() => {
          window.location.reload();
        });

        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );

        if (
          this.currentUrl.trim() === "Membership%20Form" ||
          this.currentUrl.trim() === "Refer%20Yourself" ||
          this.currentUrl.trim() === "Refer%20a%20Patient" ||
          this.currentUrl.trim() === "CBCT%20Referal" ||
          this.currentUrl.trim() === "Join%20Us" ||
          this.currentUrl.trim() === "Contact%20Us" ||
          this.currentUrl.trim() === "Book%20an%20appointment" ||
          this.currentUrl.trim() === "Log%20In" ||
          this.currentUrl.trim().split(";")[0] === "Log%20In" ||
          this.currentUrl.trim() === "Membership%20Form" ||
          this.currentUrl.trim().split(";")[0] === "Membership%20Form" ||
          this.currentUrl.trim().split("?")[0] === "VideoCall" ||
          this.currentUrl.trim().split(";")[0] === "referal-dentist-login" ||
          this.currentUrl.trim() === "forgotpassword" ||
          this.currentUrl.trim().split("?")[0] === "forgotpassword" ||
          this.currentUrl.trim().split(";")[0] === "forgotpassword" ||
          this.currentUrl.trim() === "payment" ||
          this.currentUrl.trim().split("?")[0] === "payment"
        ) {
          this.isNoForm = false;
        } else {
          this.isNoForm = true;
        }

        if (this.currentUrl.trim().split("?")[0] === "VideoCall") {
          this.noFooter = true;
        } else {
          this.noFooter = false;
        }
        if (
          this.currentUrl.trim() === "Contact%20Us" ||
          this.currentUrl.trim().split(";")[0] === "Contact%20Us"
        ) {
          $("#topValue").addClass("mt-5");
          $("#topValue").addClass("pt-5");
        } else {
          $("#topValue").removeClass("mt-5");
          $("#topValue").removeClass("pt-5");
        }
      }
    });
  }

  ngOnInit() {
    this.isReadOnly=false;
    this.route.params.subscribe((params) => {
      this.PlanID = params["PlanID"];
      if (this.PlanID) {
        this.GetAGBTPlans();
      }
    });
    this.GetBanners();
    this.formInitialize();

    this.currentUrl = this.router.url.substring(
      this.router.url.lastIndexOf("/") + 1
    );
    if (
      this.currentUrl.trim() === "Contact%20Us" ||
      this.currentUrl.trim().split(";")[0] === "Contact%20Us"
    ) {
      $("#topValue").addClass("mt-5");
      $("#topValue").addClass("pt-5");
    } else {
      $("#topValue").removeClass("mt-5");
      $("#topValue").removeClass("pt-5");
    }
	
		
	  if (this.cookieService.get("isLoggedIn")) {
      this.isLoggedIn = true;
      this.isReadOnly=true;
    } else {
      this.isLoggedIn = false;
      this.isReadOnly=false;
    }
    if(this.isLoggedIn)
      {
        this.UserName=this.encDecService.dec(this.cookieService.get("FirstName"));
        this.Email=this.encDecService.dec(this.cookieService.get("Email"));
        this.PhoneNumber=this.encDecService.dec(this.cookieService.get("Phone"));         
      }  
  }

  formInitialize() {
    this.formVar = this.fb.group({
      name: new FormControl("", [
        Validators.required,
        Validators.pattern(environment.inputTypeTextPattern),
      ]),
      email: new FormControl("", [
        Validators.required,
        Validators.pattern(this.emailPattern),
      ]),
      phoneNumber: new FormControl("", Validators.pattern(this.phonePattern)),
      foundUs: new FormControl(""),
      Message: new FormControl("", Validators.required),
      consent1: new FormControl("", Validators.required),
      PlanIDValue: new FormControl(""),
      preferredDay: new FormControl(""),
      preferredDate: new FormControl(""),
    });
  }

  sendMessage() {
    this.loader = true;
    this.submitted = true;
    if (!this.formVar.valid) {
      this.loader = false;
      this.isFieldValidation = true;
      this.isSuccess = false;
      this.isError = false;
      $("#ModalCenter").modal("show");
      window.scrollTo(0, 0);
      return false;
    } else {
      var ContactUsData;
      if (this.PlanID) {
        ContactUsData = {
          name: this.formVar.value.name,
          email: this.formVar.value.email,
          phone: this.formVar.value.phoneNumber,
          PlanName: $("#PlanIDValue option:selected").html(),
          message: this.formVar.value.Message,
          foundfrom: "",
          PreferredDay: this.formVar.value.preferredDay,
          PreferredTime: this.formVar.value.preferredDate,
        };
      } else {
        ContactUsData = {
          name: this.formVar.value.name,
          email: this.formVar.value.email,
          phone: this.formVar.value.phoneNumber,
          foundfrom: this.formVar.value.foundUs,
          message: this.formVar.value.Message,
          PlanName: "",
          PreferredDay: this.formVar.value.preferredDay,
          PreferredTime: this.formVar.value.preferredDate,
        };
      }
      var inputData = {
        Data: this.encDecService.enc(JSON.stringify(ContactUsData)),
      };
      this.contactusService.EmailUs(inputData).subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            this.isFieldValidation = false;
            this.isSuccess = true;
            this.isError = false;
            $("#ModalCenter").modal("show");
            this.formVar.reset();
            this.submitted = false;
            this.formInitialize();
          } else {
            this.loader = false;
            this.isFieldValidation = false;
            this.isSuccess = false;
            this.isError = true;
            $("#ModalCenter").modal("show");
            // this.formVar.reset()
          }
        },
        (err) => {
          this.loader = false;
          this.isFieldValidation = false;
          this.isSuccess = false;
          this.isError = true;
          $("#ModalCenter").modal("show");
          // this.formVar.reset()
        }
      );
    }
  }

  // For AGBT enquiry
  GetAGBTPlans() {
    this.memberShipService.GetPlansbyMembershipTypeID(2).subscribe(
      (res) => {
        if (res["success"]) {
          if (res["data"] && res["data"].length > 0) {
            this.AGBTPlans = res["data"];
          }
        } else {
        }
      },
      (err) => {}
    );
  }

  GetBanners() {
    if (!localStorage.getItem("BannerDetails")) {
      this.aboutUsService.GetBannerDetails("HomePage").subscribe(
        (res) => {
          if (res["success"]) {
            localStorage.setItem("BannerDetails", JSON.stringify(res["data"]));
            this.bannerDetails = res["data"];
          } else {
            this.bannerDetails = [];
          }
        },
        (err) => {
          this.bannerDetails = [];
        }
      );
    } else {
      this.bannerDetails = JSON.parse(localStorage.getItem("BannerDetails"));
    }
  }
}
